import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBulb = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 20,
	viewBox: "0 0 19 20",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.65663 17.5586C6.43705 17.573 6.26367 17.7551 6.26367 17.9785C6.26367 18.2116 6.45148 18.3994 6.68454 18.3994H11.7121C11.9452 18.3994 12.133 18.2116 12.133 17.9785C12.133 17.7551 11.9596 17.573 11.74 17.5586H11.7121H6.68452H6.65663Z",
			fill: "#FF9790"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.88086 19.168C8.0417 19.6505 8.49725 19.9982 9.03371 19.9982H9.36599C9.90245 19.9972 10.358 19.6495 10.5188 19.168H7.88086Z",
			fill: "#FF9790"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.11761 4.50188C4.01552 4.50188 3.91728 4.46143 3.84504 4.38919L2.69508 3.23923C2.54483 3.08898 2.54387 2.8453 2.69508 2.69508C2.84532 2.54483 3.089 2.54387 3.23923 2.69508L4.38823 3.846C4.63094 4.08871 4.45661 4.50382 4.11566 4.50286L4.11761 4.50188Z",
			fill: "#FFB13B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.50351 15.9897C6.49677 15.9936 6.49099 15.9964 6.48425 16.0003C6.35327 16.0716 6.26562 16.2103 6.26562 16.3701C6.26562 16.5936 6.43898 16.7756 6.65859 16.79H6.68556C6.69615 16.79 6.70674 16.79 6.71638 16.791H11.6813C11.6919 16.79 11.7015 16.79 11.7121 16.79H11.74C11.9596 16.7756 12.134 16.5936 12.134 16.3701C12.134 16.1371 11.9462 15.9493 11.7131 15.9493H6.68555C6.62006 15.9483 6.55841 15.9627 6.50351 15.9897Z",
			fill: "#FF9790"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.6896 15.1778H8.81519V13.1274L7.49959 11.8012C7.3426 11.6576 7.33104 11.4149 7.47455 11.257C7.62768 11.0894 7.89253 11.0894 8.04471 11.258L9.19948 12.4204L10.3543 11.258C10.5035 11.1068 10.7482 11.1058 10.8984 11.256C11.0496 11.4063 11.0506 11.65 10.9003 11.8002L9.58473 13.1264V15.1769H11.7142C11.6978 14.6231 11.7642 13.1399 12.9161 11.7924C13.6635 10.9111 14.0719 9.79295 14.0709 8.63719C14.0661 5.99632 11.9145 3.81873 9.27562 3.78125H9.19954C6.51256 3.78125 4.33398 5.9598 4.33398 8.6468C4.33398 9.80734 4.74909 10.9294 5.50321 11.8106C6.30452 12.7487 6.72635 13.9497 6.68976 15.1776L6.6896 15.1778ZM5.46645 9.29325C5.25361 9.29325 5.08121 9.12085 5.08121 8.90801C5.08121 6.60618 6.96601 4.75796 9.25739 4.79174C9.47024 4.79463 9.63975 4.96992 9.63686 5.18179C9.63397 5.39464 9.45869 5.56415 9.24681 5.56127C7.39763 5.53526 5.87786 7.01267 5.85172 8.86192C5.85172 8.8783 5.85076 8.89274 5.85076 8.90912C5.85269 9.121 5.68027 9.29325 5.46645 9.29325Z",
			fill: "url(#paint0_linear_8535_131012)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.1997 2.39624C8.98685 2.39624 8.81445 2.22384 8.81445 2.01099V0.385245C8.81445 0.172397 8.98685 0 9.1997 0C9.41255 0 9.58494 0.172397 9.58494 0.385245V2.01195C9.58398 2.2248 9.41158 2.39624 9.1997 2.39624Z",
			fill: "#FFB13B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.8965 4.11798C13.8965 4.01589 13.937 3.91862 14.0092 3.84637L15.1592 2.69544C15.3133 2.54905 15.5569 2.55579 15.7033 2.70989C15.8449 2.85917 15.8449 3.09129 15.7033 3.24056L14.5524 4.39148C14.3116 4.63226 13.8955 4.46085 13.8965 4.11798Z",
			fill: "#FFB13B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.0139 9.58299H16.3872C16.1744 9.58299 16.002 9.41059 16.002 9.19775C16.002 8.9849 16.1744 8.8125 16.3872 8.8125H18.0139C18.2268 8.8125 18.3992 8.9849 18.3992 9.19775C18.3982 9.41059 18.2268 9.58299 18.0139 9.58299Z",
			fill: "#FFB13B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.01195 9.58299H0.385245C0.172397 9.58299 0 9.41059 0 9.19775C0 8.9849 0.172397 8.8125 0.385245 8.8125H2.01195C2.2248 8.8125 2.3972 8.9849 2.3972 9.19775C2.39623 9.41059 2.2248 9.58299 2.01195 9.58299Z",
			fill: "#FFB13B"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_8535_131012",
			x1: 4.33398,
			y1: 9.47954,
			x2: 14.0709,
			y2: 9.47954,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF9790" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FFB13B"
			})]
		}) })
	]
});
export { SvgIconBulb as ReactComponent };
